import axios from "axios";

import { getTenantHeaders } from "fe-shared/src/helpers/tenantUtils";

import { getIdentityHostUrl } from "config";
export interface SetPasswordParams {
  token: string;
  email: string;
  password: string;
  confirmedPassword: string;
  isFirstLogin: boolean;
}

export interface SetPasswordResponse {
  token: string;
}

export const setPassword = ({
  confirmedPassword,
  password,
  email,
  token,
  isFirstLogin,
}: SetPasswordParams): Promise<SetPasswordResponse> => {
  const apiClient = axios.create({
    baseURL: getIdentityHostUrl(),
    headers: { ...getTenantHeaders(), ...axios.defaults.headers },
  });

  return apiClient
    .post(
      "api/account/resetPassword",
      {
        email,
        token,
        password,
        confirmedPassword,
        rememberMe: true,
        isFirstLogin,
      },
      { hideToast: true }
    )
    .then((res) => res.data);
}
